export enum PermissionEnum {
  ACCESS_ALL_ACCOUNTS = 'ACCESS_ALL_ACCOUNTS',
  ACCESS_ALL_ACCESS_MEDIA = 'ACCESS_ALL_ACCESS_MEDIA',
  ACCESS_ALL_ACTIVITIES = 'ACCESS_ALL_ACTIVITIES',
  ACCESS_ALL_ADDRESSES = 'ACCESS_ALL_ADDRESSES',
  ACCESS_ALL_BILLS = 'ACCESS_ALL_BILLS',
  ACCESS_ALL_CARTS = 'ACCESS_ALL_CARTS',
  ACCESS_ALL_CONSENTS = 'ACCESS_ALL_CONSENTS',
  ACCESS_ALL_CONTRACTS = 'ACCESS_ALL_CONTRACTS',
  ACCESS_ALL_DEBTS = 'ACCESS_ALL_DEBTS',
  ACCESS_ALL_DOC_PROOF = 'ACCESS_ALL_DOC_PROOF',
  ACCESS_ALL_EVENTS = 'ACCESS_ALL_EVENTS',
  ACCESS_ALL_INVOICES = 'ACCESS_ALL_INVOICES',
  ACCESS_ALL_PAYMENT_MEANS = 'ACCESS_ALL_PAYMENT_MEANS',
  ACCESS_ALL_PAYMENTS = 'ACCESS_ALL_PAYMENTS',
  ACCESS_ALL_ORDERS = 'ACCESS_ALL_ORDERS',
  ACCESS_ALL_PROFILES = 'ACCESS_ALL_PROFILES',
  ACCESS_ALL_PROFILE_REQUESTS = 'ACCESS_ALL_PROFILE_REQUESTS',
  ACCESS_ALL_PURCHASES = 'ACCESS_ALL_PURCHASES',
  ACCESS_ALL_RECEIPTS = 'ACCESS_ALL_RECEIPTS',
  ACCESS_ALL_SUBSCRIPTIONS = 'ACCESS_ALL_SUBSCRIPTIONS',
  ACCESS_ALL_TARIFFS = 'ACCESS_ALL_TARIFFS',
  ACCESS_ALL_TRANSPORT_OFFERS = 'ACCESS_ALL_TRANSPORT_OFFERS',
  ACCESS_ALL_USERS = 'ACCESS_ALL_USERS',
  ACCESS_ALL_WORKFLOWS = 'ACCESS_ALL_WORKFLOWS',
  ACCESS_CONTROLS = 'ACCESS_CONTROLS',
  ACCESS_PROFILE_TYPES = 'ACCESS_PROFILE_TYPES',
  ACCESS_STATISTICS = 'ACCESS_STATISTICS',
  ACCESS_TICKETS = 'ACCESS_TICKETS',
  CONFIGURE_MY_USER = 'CONFIGURE_MY_USER',
  CONFIGURE_TARIFF = 'CONFIGURE_TARIFF',
  DISTRIBUTE_CONTRACT_DEFAULT = 'DISTRIBUTE_CONTRACT_DEFAULT',
  DISTRIBUTE_PRODUCT = 'DISTRIBUTE_PRODUCT',
  MANAGE_ALARM = 'MANAGE_ALARM',
  MANAGE_APPORTIONMENT = 'MANAGE_APPORTIONMENT',
  MANAGE_INVOICE_TEMPLATE = 'MANAGE_INVOICE_TEMPLATE',
  MANAGE_PROFILE_TYPES = 'MANAGE_PROFILE_TYPES',
  MANAGE_RECEIPT_TEMPLATE = 'MANAGE_RECEIPT_TEMPLATE',
  MANAGE_REFUND = 'MANAGE_REFUND',
  MANAGE_ROLES = 'MANAGE_ROLES',
  MANAGE_SAV_TICKETS = 'MANAGE_SAV_TICKETS',
  MANAGE_STATISTICS = 'MANAGE_STATISTICS',
  MANAGE_SUBSCRIPTIONS = 'MANAGE_SUBSCRIPTIONS',
  MANAGE_VALIDATION_REQUEST = 'MANAGE_VALIDATION_REQUEST',
  REMOVE_ACCOUNT = 'REMOVE_ACCOUNT',
  ACCESS_APP_CONFIGURATION = 'ACCESS_APP_CONFIGURATION',
  ACCESS_ALL_IDENTITY_REQUESTS = 'ACCESS_ALL_IDENTITY_REQUESTS',
  ACCESS_MONITORING_TERMINAL = "ACCESS_MONITORING_TERMINAL",
  ACCESS_MY_USER = 'ACCESS_MY_USER',
  ACCESS_PRODUCT = 'ACCESS_PRODUCT',
  ACCESS_RULES_PARAMETERS = 'ACCESS_RULES_PARAMETERS',
  ACCESS_STATISTICS_TERMINAL = 'ACCESS_STATISTICS_TERMINAL',
  ACCESS_TARIFF = 'ACCESS_TARIFF',
  ACCESS_TERMINAL_HISTORY_DETAILS = 'ACCESS_TERMINAL_HISTORY_DETAILS',
  ACCESS_TERMINAL_INFO = 'ACCESS_TERMINAL_INFO',
  ACCESS_TERMINAL_LOG = 'ACCESS_TERMINAL_LOG',
  ACCESS_TERMINAL_SUPERVISION = 'ACCESS_TERMINAL_SUPERVISION',
  ACCESS_TOPOLOGY = 'ACCESS_TOPOLOGY',
  BLOCK_TERMINALS = 'BLOCK_TERMINALS',
  CONFIGURE_MAIN_TERMINAL = 'CONFIGURE_MAIN_TERMINAL',
  CONFIGURE_TERMINAL = 'CONFIGURE_TERMINAL',
  CREATE_TAP = 'CREATE_TAP',
  FULL_CONFIGURE_TERMINAL = 'FULL_CONFIGURE_TERMINAL',
  LOGIN_CONTROLER = 'LOGIN_CONTROLER',
  ACCESS_ALL_ADDRESS_REQUESTS = 'ACCESS_ALL_ADDRESS_REQUESTS',
  ACCESS_ADMIN_TOOLS = 'ACCESS_ADMIN_TOOLS',
  UPDATE_SUBSCRIPTION_ACTIVE = 'UPDATE_SUBSCRIPTION_ACTIVE',
  UPDATE_SUBSCRIPTION_TERMINATED = 'UPDATE_SUBSCRIPTION_TERMINATED',
  MANAGE_EXTERNAL_REGULARIZATION = 'MANAGE_EXTERNAL_REGULARIZATION'
}
